import { CurrencyPipe, registerLocaleData } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Currency, CurrencyCode } from '@app/model/currency';

@Pipe({ name: 'value' })
export class ValuePipe implements PipeTransform {
  transform(value: Currency, useSymbol?: boolean): string {
    if (!value) {
      return 'null';
    }

    // We sometimes want to display the symbol instead for SEK/DKK,
    // other currencies however always displays as a symbol (same as link-checkout).
    const codeOrSymbol = useSymbol ? 'symbol' : 'code';

    switch (value.currencyCode) {
      case CurrencyCode.SEK:
        return new CurrencyPipe('sv', 'SEK').transform(
          value.amount,
          value.currencyCode,
          codeOrSymbol,
          '1.2-2',
          'sv'
        );
      case CurrencyCode.DKK:
        return new CurrencyPipe('da', 'DKK').transform(
          value.amount,
          value.currencyCode,
          codeOrSymbol,
          '1.2-2',
          'da'
        );
      case CurrencyCode.EUR:
        return new CurrencyPipe('de').transform(
          value.amount,
          value.currencyCode,
          'symbol',
          '1.2-2'
        );
      case CurrencyCode.NOK:
        return new CurrencyPipe('nb', 'NOK').transform(
          value.amount,
          value.currencyCode,
          'symbol',
          '1.2-2',
          'nb'
        );
      default:
        console.error(
          'Unimplemented currency in value pipe: ',
          value.currencyCode
        );
    }
  }
}
